import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Attach token from localStorage to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ct-token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  // Cache-busting pro GET — brání prohlížeči/CDN vrátit zastaralá data
  // (jinak se nově vytvořené/upravené záznamy nemusí v seznamech hned objevit).
  const method = (config.method || 'get').toLowerCase();
  if (method === 'get') {
    config.params = { ...(config.params || {}), _t: Date.now() };
    config.headers['Cache-Control'] = 'no-cache';
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('ct-token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
